export const headers = [
  { label: "User", key: "user" },
  { label: "Permissions", key: "permissions" },
  { label: "Last Active", key: "lastActive" },
  { label: "Date Added", key: "dateAdded" },
  { label: "Action", key: "action" }
];
